export const AUTH_FREE_PATHS = ['/login', '/forgot-password', '/register'];

export const isAuthFreePath = (pathname = '') =>
    AUTH_FREE_PATHS.some(
        (path) => pathname === path || pathname.startsWith(`${path}/`)
    );
